import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { cva, type VariantProps } from "@maker/utils/cva";

type ButtonVariants = VariantProps<typeof buttonVariants>;

const buttonVariants = cva(
	"group/button inline-flex cursor-pointer items-center gap-1 rounded font-medium outline-none focus-visible:ring-1 focus-visible:ring-blue-600",
	{
		variants: {
			variant: {
				white:
					"border border-neutral-200 bg-white text-neutral-900 hover:bg-neutral-100 focus-visible:border-blue-600",
				black:
					"border border-neutral-900 bg-neutral-900 text-white hover:border-neutral-700 hover:bg-neutral-700 focus-visible:border-blue-600 disabled:pointer-events-none disabled:opacity-35",
				blue: "border border-blue-600 bg-blue-600 text-white hover:border-blue-700 hover:bg-blue-700 focus-visible:border-blue-600",
				neutral:
					"border border-neutral-100 bg-neutral-100 text-neutral-900 hover:border-neutral-200 hover:bg-neutral-200 focus-visible:border-blue-600 focus-visible:ring-blue-600",
			},
			text: {
				inherit: "text-left hover:underline focus-visible:ring-2",
				black:
					"text-left text-neutral-900 hover:underline focus-visible:ring-2 focus-visible:ring-blue-600",
				blue: "text-left text-blue-500 hover:underline focus-visible:ring-2 focus-visible:ring-blue-600",
			},
			size: {
				base: "px-3 py-1.5 text-base [&_svg]:w-5",
				sm: "px-2.5 py-1.25 text-sm [&_svg]:w-4",
				xs: "px-1.5 py-0.75 text-xs [&_svg]:w-3",
			},
			icon: {
				base: "p-1.5 [&_svg]:h-6 [&_svg]:w-6",
				sm: "p-1.25 [&_svg]:h-5 [&_svg]:w-5",
				xs: "p-0.75 [&_svg]:h-4 [&_svg]:w-4",
			},
			modifier: {
				ghost: "border-0 bg-transparent focus-visible:ring-2",
				outline: "bg-transparent focus-visible:ring-2",
			},
		},
		defaultVariants: {},
	},
);

function Button({
	className,
	variant,
	text,
	size,
	icon,
	modifier,
	...props
}: ButtonPrimitive.Props & ButtonVariants) {
	return (
		<ButtonPrimitive
			data-slot="button"
			className={buttonVariants({
				variant,
				text,
				size,
				icon,
				modifier,
				className,
			})}
			{...props}
		/>
	);
}

export { Button, buttonVariants, type ButtonVariants };
